module.exports = __webpack_public_path__ + "static/media/achievement_02.02e6815b.png";